import { ChangeDetectorRef, Component, Inject, NgZone, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet, RouterLinkWithHref } from '@angular/router';

//Stripe Elements?  
import { CommonModule } from '@angular/common';

import { FirebaseInit, LocalDataService, WebPlatformAPI } from 'mlng';
import { MainPageGrid, FlexRowContainer, GlassLayerComponent, DLButtonsChipsMenuItem } from 'mlng';
import { environment } from '../www/environments/environment';
import { DataServiceDownloader } from 'mlng';
import { APP_GLASS_LAYERS } from '../config/app.glass.layers';
import { MLLog, PlatformReference } from 'mlng';
import { globalMenuItems } from '../config/app.mainmenu.config';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet,
    MainPageGrid, FlexRowContainer,
    GlassLayerComponent
    , RouterLinkWithHref],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  title = 'EurovisionPlayground';
  //mode = 1;//mode development tests
  mode = 100; //Production version 01
  screenAsset = "assets/Fullscreen.svg";

  glassLayers = APP_GLASS_LAYERS;
  menuItems: DLButtonsChipsMenuItem[] = globalMenuItems;

  test = true;

  @ViewChild("mainpg") mainPageGrid!: MainPageGrid;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private firebaseInit: FirebaseInit,
    private router: Router,
    private localDataService: LocalDataService,
    private webPlatformAPI: WebPlatformAPI

  ) {

    PlatformReference.setup(platformId)
    localDataService.load();

    MLLog.logEnv("Actual Firebase" + environment.FIREBASE_CONFIG)
    MLLog.mute(environment.MUTE_LOG);
    if (environment.REPORT_ENV) {
      MLLog.logEnv("Actual Environment " + environment.NAME)
      MLLog.logEnv("Actual Firebase " + environment.FIREBASE_CONFIG.authDomain)
      MLLog.logEnv("Actual Service " + environment.ML_USERS_SERVICE_URL)
      if (environment.TEST_ROUTES) {
        MLLog.logEnv("Test Routes have been loaded!!")
      }
    }

    this.firebaseInit.setupConfig(environment.FIREBASE_CONFIG)
    DataServiceDownloader.setBasePathData(environment.ML_DATA_SERVICE_URL)
    //WebPlatformAPI.setBasePathService(environment.ML_USERS_SERVICE_URL)
    // webPlatformAPI.setFirebaseInit(firebaseInit)
    //webPlatformAPI.setLocalDataService(localDataService)
  }


  public closeSide() {
    if (this.mainPageGrid != null) {
      this.mainPageGrid.closeSide();
    }
  }


  //assets/Fullscreen.svg
  //assets/FullscreenOut.svg

  public updateScreenAsset() {
    /*if(document.fullscreenElement != null){
      this.screenAsset = "assets/FullscreenOut.svg"; 
    }else{*/
    this.screenAsset = "assets/Fullscreen.svg";
    //} 
  }

  public get isFullScreen() {
    return document.fullscreenElement !== null;
  }

  public fullscreen() {

    if (document.fullscreenElement == null) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    this.updateScreenAsset();

  }

  public openSettings() {
    this.router.navigate(["/settings"]);
  }

  public user() {
    this.router.navigate(["/users"]);
  }


  public login() {
    this.router.navigate(["/login"]);
  }

  public home() {
    this.router.navigate(["/"]);
  }

  public routeTo(path: string) {
    this.router.navigate([path]);

  }

  public isFirstAccess() {
    //MLLog.logDev("is first access??")
    //MLLog.logDev(this.localDataService.localData.localDataAccepted);
    return !this.localDataService.localData.localDataAccepted;
  }
}
